import { useApiQuery } from '@/shared/hooks/useApi';
import { api } from '@/shared/services/api';
import { Contact } from '@/Users/types/userTypes';

export const useContactDetail = (contactId: number) => {
  const {
    data: contactDetailResponse,
    isLoading,
    isError,
    error,
    refetch,
  } = useApiQuery(
    ['contact', 'detail', contactId],
    () => api.get<Contact>(`/api/v1/contact/detail/${contactId}`),
    {
      enabled: !!contactId,
    },
  );

  return {
    contactDetail: contactDetailResponse?.data,
    isLoading,
    isError,
    error,
    refetch,
  };
};
